<template>
    <div></div>
</template>

<style lang="scss">
    .c-toast-container {
        opacity: 0.9 !important;
        z-index: 30000 !important;
    }
    .c-toast {
        box-shadow: 0 0 12px #999 !important;
        position: relative;
        padding-left: 3em !important;
        font-size: 16px;
        background-position: 10px 50%;
        background-repeat: no-repeat;
    }
    .c-toast--success {
        background-image: url('~@/assets/img/checkmark.png');
    }
    .c-toast--info {
        background-color: #17a2b8 !important;
        background-image: url('~@/assets/img/info.png');
    }
    .c-toast--warning {
        background-color: $danger-medium !important;
        background-image: url('~@/assets/img/warning.png');
    }
    .c-toast--error {
        background-color: $danger-high !important;
        background-image: url('~@/assets/img/warning.png');
    }
    @keyframes fadeInDown {
        from {
            opacity: 0 !important;
            transform: translate3d(0, -100%, 0);
        }
        to {
            opacity: 1;
            transform: none;
        }
    }
    @keyframes fadeOutUp {
        from {
            opacity: 1 !important;
            transform: translate3d(-100%, 0, 0);
        }
        to {
            opacity: 0;
            transform: none;
        }
    }
</style>

